import { SingleReview  } from '../models/Cosmetic';
import { axiosWrapper } from '../clients/axiosWrapper';
import { Profile } from '../models/Profile';

const getReviews = async (username: string): Promise<Profile> => {
    const response: any = await axiosWrapper.get(`profile?username=${username}`);
    return response;
}

const getFilteredReviews = async (username: string, filter: string): Promise<SingleReview[]> => {
    const response: any = await axiosWrapper.get(`profile?username=${username}&search=${filter}`);
    return response.reviews;
}

const getProfiles = async (username: string, page: number): Promise<Profile[]> => {
    const response: any = await axiosWrapper.get(`profiles?search=${username}&page=${page}`);
    return response;
}


export const profileService = {
    getReviews,
    getFilteredReviews,
    getProfiles
};